var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var DiversityParams_1;
import { JSON, JsonDiscriminatorValue, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { SolutionType } from '../solutionType';
import { SolutionParams } from './solutionParams';
export var Gender;
(function (Gender) {
    Gender["Male"] = "Male";
    Gender["Female"] = "Female";
})(Gender || (Gender = {}));
export var DiversityParamNames;
(function (DiversityParamNames) {
    DiversityParamNames["EmployeeDataSourceID"] = "dataSourceID";
    DiversityParamNames["EmployeeRaceColumn"] = "raceColumn";
    DiversityParamNames["EmployeeGenderColumn"] = "genderColumn";
    DiversityParamNames["EmployeeGenderValueType"] = "genderValueType";
    DiversityParamNames["EmployeeMaleValue"] = "maleValue";
    DiversityParamNames["EmployeeFemaleValue"] = "femaleValue";
    DiversityParamNames["EmployeePositionColumn"] = "positionColumn";
    DiversityParamNames["EmployeeDateHiredColumn"] = "dateHiredColumn";
    DiversityParamNames["EmployeeDateLeftColumn"] = "dateLeftColumn";
    DiversityParamNames["EmployeeSeniorityColumn"] = "employeeSeniorityColumn";
    DiversityParamNames["EmployeeSeniorityValueType"] = "employeeSeniorityValueType";
    DiversityParamNames["EmployeeSeniorityExecutiveValue"] = "employeeExecutiveValue";
    DiversityParamNames["HiringDataSourceID"] = "hiringDataSourceID";
    DiversityParamNames["HiringRaceColumn"] = "hiringRaceColumn";
    DiversityParamNames["HiringPositionColumn"] = "hiringPositionColumn";
    DiversityParamNames["HiringDateColumn"] = "hiringDateColumn";
    DiversityParamNames["HiringSeniorityColumn"] = "hiringSeniorityColumn";
    DiversityParamNames["HiringSeniorityValueType"] = "hiringSeniorityValueType";
    DiversityParamNames["HiringSeniorityExecutiveValue"] = "hiringExecutiveValue";
    DiversityParamNames["HiringHiredColumn"] = "hiringHiredColumn";
    DiversityParamNames["HiringHiredValueType"] = "hiringHiredValueType";
    DiversityParamNames["HiringHiredValue"] = "hiredValue";
})(DiversityParamNames || (DiversityParamNames = {}));
const schema = {
    $id: 'urn:wisepipe-solution-domain:DiversityParams',
    type: 'object',
    properties: {
        raceColumn: { type: 'string', minLength: 1 },
        genderColumn: { type: 'string', minLength: 1 },
        maleValue: { type: 'string', minLength: 1 },
        femaleValue: { type: 'string', minLength: 1 },
        positionColumn: { type: 'string', minLength: 1 },
        dateHiredColumn: { type: 'string', minLength: 1 },
        dateLeftColumn: {
            type: 'string',
            minLength: 1,
            not: {
                const: {
                    $data: '1/dateHiredColumn'
                }
            }
        },
        employeeSeniorityColumn: { type: 'string', minLength: 1 },
        employeeExecutiveValue: { type: 'string', minLength: 1 },
        hiringDataSourceID: { type: 'string', minLength: 1 },
        hiringRaceColumn: { type: 'string', minLength: 1 },
        hiringPositionColumn: { type: 'string', minLength: 1 },
        hiringDateColumn: { type: 'string', minLength: 1 },
        hiringSeniorityColumn: { type: 'string', minLength: 1 },
        hiringExecutiveValue: { type: 'string', minLength: 1 },
        hiringHiredColumn: { type: 'string', minLength: 1 },
        hiredValue: { type: 'string', minLength: 1 }
    },
    required: []
};
let DiversityParams = DiversityParams_1 = class DiversityParams extends SolutionParams {
    constructor(raceColumn, genderColumn, positionColumn, dateHiredColumn, dateLeftColumn, employeeSeniorityColumn, employeeExecutiveValue, hiringDataSourceID, hiringRaceColumn, hiringPositionColumn, hiringDateColumn, hiringSeniorityColumn, hiringSeniorityExecutiveValue, hiringHiredColumn, hiringHiredValue) {
        super(SolutionType.Diversity);
        this.raceColumn = raceColumn;
        this.genderColumn = genderColumn;
        this.positionColumn = positionColumn;
        this.dateHiredColumn = dateHiredColumn;
        this.dateLeftColumn = dateLeftColumn;
        this.employeeSeniorityColumn = employeeSeniorityColumn;
        this.employeeExecutiveValue = employeeExecutiveValue;
        this.hiringDataSourceID = hiringDataSourceID;
        this.hiringRaceColumn = hiringRaceColumn;
        this.hiringPositionColumn = hiringPositionColumn;
        this.hiringDateColumn = hiringDateColumn;
        this.hiringSeniorityColumn = hiringSeniorityColumn;
        this.hiringExecutiveValue = hiringSeniorityExecutiveValue;
        this.hiringHiredColumn = hiringHiredColumn;
        this.hiredValue = hiringHiredValue;
        JSON.validate(this, DiversityParams_1);
    }
    get extraDataSourceIDs() {
        return this.hiringDataSourceID ? [this.hiringDataSourceID] : [];
    }
    toTemplateParams(dataSource, extraDataSources) {
        const params = new Map();
        this.requiredParams.forEach((param) => {
            if (!this[param]) {
                throw new Error(`Required parameter '${param}' for Diversity App must be provided.`);
            }
        });
        /* ---------- Employee Diversity Start ---------- */
        if (!dataSource.columns) {
            throw new Error(`Zero columns found for data source ${dataSource.dataSourceID}`);
        }
        const columnNames = dataSource.columns.map((c) => c.name);
        if (!columnNames.includes(this.raceColumn))
            throw new Error(`Column ${this.raceColumn} not in data source ${dataSource.dataSourceID}`);
        if (!columnNames.includes(this.genderColumn))
            throw new Error(`Column ${this.genderColumn} not in data source ${dataSource.dataSourceID}`);
        if (!columnNames.includes(this.positionColumn))
            throw new Error(`Column ${this.positionColumn} not in data source ${dataSource.dataSourceID}`);
        if (!columnNames.includes(this.dateHiredColumn))
            throw new Error(`Column ${this.dateHiredColumn} not in data source ${dataSource.dataSourceID}`);
        if (!columnNames.includes(this.dateLeftColumn))
            throw new Error(`Column ${this.dateLeftColumn} not in data source ${dataSource.dataSourceID}`);
        if (!columnNames.includes(this.employeeSeniorityColumn))
            throw new Error(`Column ${this.employeeSeniorityColumn} not in data source ${dataSource.dataSourceID}`);
        // Set the params
        const genderColumn = dataSource.columns.find((c) => c.name === this.genderColumn);
        const employeeSeniorityColumn = dataSource.columns.find((c) => c.name === this.employeeSeniorityColumn);
        params.set(DiversityParamNames.EmployeeDataSourceID, dataSource.dataSourceID);
        params.set(DiversityParamNames.EmployeeRaceColumn, this.raceColumn);
        params.set(DiversityParamNames.EmployeeGenderColumn, this.genderColumn);
        params.set(DiversityParamNames.EmployeeGenderValueType, genderColumn.type);
        params.set(DiversityParamNames.EmployeePositionColumn, this.positionColumn);
        params.set(DiversityParamNames.EmployeeDateHiredColumn, this.dateHiredColumn);
        params.set(DiversityParamNames.EmployeeDateLeftColumn, this.dateLeftColumn);
        params.set(DiversityParamNames.EmployeeSeniorityColumn, this.employeeSeniorityColumn);
        params.set(DiversityParamNames.EmployeeSeniorityValueType, employeeSeniorityColumn.type);
        params.set(DiversityParamNames.EmployeeSeniorityExecutiveValue, this.employeeExecutiveValue);
        /* ---------- Employee Diversity End ---------- */
        /* ---------- Hiring Diversity Start ---------- */
        if (this.hiringDataSourceID) {
            if (!extraDataSources || extraDataSources.length === 0 || !extraDataSources[0].columns) {
                throw new Error(`Zero columns found for secondary data source ${this.hiringDataSourceID}`);
            }
            const hiringDataSourceColumns = extraDataSources[0].columns;
            const hiringDataSourceColumnNames = hiringDataSourceColumns.map((c) => c.name);
            [
                this.hiringRaceColumn,
                this.hiringPositionColumn,
                this.hiringDateColumn,
                this.hiringSeniorityColumn,
                this.hiringHiredColumn
            ].forEach((col) => {
                if (!hiringDataSourceColumnNames.includes(col))
                    throw new Error(`Column ${col} not in data source ${this.hiringDataSourceID}`);
            });
            // Set the params
            const hiringSeniorityColumn = hiringDataSourceColumns.find((c) => c.name === this.hiringSeniorityColumn);
            const hiringHiredColumn = hiringDataSourceColumns.find((c) => c.name === this.hiringHiredColumn);
            params.set(DiversityParamNames.HiringDataSourceID, this.hiringDataSourceID);
            params.set(DiversityParamNames.HiringRaceColumn, this.hiringRaceColumn);
            params.set(DiversityParamNames.HiringPositionColumn, this.hiringPositionColumn);
            params.set(DiversityParamNames.HiringDateColumn, this.hiringDateColumn);
            params.set(DiversityParamNames.HiringSeniorityColumn, this.hiringSeniorityColumn);
            params.set(DiversityParamNames.HiringSeniorityValueType, hiringSeniorityColumn.type);
            params.set(DiversityParamNames.HiringSeniorityExecutiveValue, this.hiringExecutiveValue);
            params.set(DiversityParamNames.HiringHiredColumn, this.hiringHiredColumn);
            params.set(DiversityParamNames.HiringHiredValueType, hiringHiredColumn.type);
            params.set(DiversityParamNames.HiringHiredValue, this.hiredValue);
        }
        /* ---------- Hiring Diversity End ---------- */
        return params;
    }
    get partialComplete() {
        const partialParams = new Set([
            DiversityParamNames.EmployeeSeniorityExecutiveValue,
            DiversityParamNames.HiringSeniorityExecutiveValue
        ]);
        return this.requiredParams.every((param) => this[param] !== undefined || partialParams.has(param));
    }
    get allParams() {
        return [
            DiversityParamNames.EmployeeRaceColumn,
            DiversityParamNames.EmployeeGenderColumn,
            DiversityParamNames.EmployeePositionColumn,
            DiversityParamNames.EmployeeDateHiredColumn,
            DiversityParamNames.EmployeeDateLeftColumn,
            DiversityParamNames.EmployeeSeniorityColumn,
            DiversityParamNames.EmployeeSeniorityExecutiveValue,
            DiversityParamNames.HiringDataSourceID,
            DiversityParamNames.HiringRaceColumn,
            DiversityParamNames.HiringPositionColumn,
            DiversityParamNames.HiringDateColumn,
            DiversityParamNames.HiringSeniorityColumn,
            DiversityParamNames.HiringSeniorityExecutiveValue,
            DiversityParamNames.HiringHiredColumn,
            DiversityParamNames.HiringHiredValue
        ];
    }
    get optionalParams() {
        if (this.hiringDataSourceID) {
            return [];
        }
        return [
            DiversityParamNames.HiringDataSourceID,
            DiversityParamNames.HiringRaceColumn,
            DiversityParamNames.HiringPositionColumn,
            DiversityParamNames.HiringDateColumn,
            DiversityParamNames.HiringSeniorityColumn,
            DiversityParamNames.HiringSeniorityExecutiveValue,
            DiversityParamNames.HiringHiredColumn,
            DiversityParamNames.HiringHiredValue
        ];
    }
    get size() {
        return DiversityParams_1.size();
    }
    static size() {
        return 17;
    }
};
DiversityParams = DiversityParams_1 = __decorate([
    JsonSchema(schema),
    JsonDiscriminatorValue(SolutionType.Diversity)
], DiversityParams);
export { DiversityParams };
//# sourceMappingURL=diversityParams.js.map